import {
  createAction,
  createStoreAction,
} from '@cobuildlab/react-simple-state';
import {
  createSharedCouponEvent,
  createSharedCouponEventError,
  editCouponEvent,
  editCouponEventError,
  enableOrDisableStripeCouponEvent,
  enableOrDisableStripeCouponEventError,
} from './coupon-events';
import axios from 'axios';
import moment from 'moment';
import { couponFilterStore } from './coupon-store';
import { BACKEND_ENDPOINT } from '../../../shared/constants';
import { PlanStripeCouponType } from '../plan-types';

export const couponFilterStoreAction = createStoreAction(
  couponFilterStore,
  (prev, status: string, expired: boolean) => ({
    ...prev,
    status,
    expired,
  }),
);

export const createSharedCoupon = createAction(
  createSharedCouponEvent,
  createSharedCouponEventError,
  async (data: {
    
    couponId: number;
    emails: string[];
    isReferral: boolean;
  }) => {
    const { couponId, emails, isReferral } = data;

    const urlShared = `${BACKEND_ENDPOINT}/api/coupon/${couponId}/shared-coupon`;
    const urlReferral = `${BACKEND_ENDPOINT}/api/coupon/${couponId}/assign-referral-coupon`;
    const url = isReferral ? urlReferral : urlShared;

    try {
      await axios.post(url, { emails }, { timeout: 60000 });
    } catch (error: any) {
      console.log('error', error);
      const msg =
        error?.response?.data?.message ?? 'Error al compartir el cupón';
      throw new Error(msg);
    }
  },
);

export const enableOrDisableStripeCoupon = createAction(
  enableOrDisableStripeCouponEvent,
  enableOrDisableStripeCouponEventError,
  async (data: {  couponId: number }) => {
    const { couponId } = data;

    const url = `${BACKEND_ENDPOINT}/api/coupon/${couponId}/toggle`;

    try {
      const response = await axios.post<PlanStripeCouponType>(url);

      return response.data;
    } catch (error: any) {
      console.log('error', error);
      const msg =
        error?.response?.data?.message ?? 'Error al actualizar el cupón';
      throw new Error(msg);
    }
  },
);

export const editCoupon = createAction(
  editCouponEvent,
  editCouponEventError,
  async (data: {
    
    id: number;
    plans: string[];
    name: string;
    discountType: string;
    maxRedemptions?: number | null;
    expirationDate?: string | null;
    isPublic?: boolean;
    isForSharing?: boolean;
  }) => {
    const { id, plans } = data;
    const url = `${BACKEND_ENDPOINT}/api/update-coupon/${id}`;

    try {
      const response = await axios.post<PlanStripeCouponType>(url, {
        couponName: data.name,
        discountType: data.discountType,
        maxRedemptions: data.maxRedemptions,
        expirationDate: data?.expirationDate
          ? moment(data.expirationDate).toISOString()
          : null,
        isPublic: data.isPublic,
        isForSharing: data.isForSharing,
        plans,
      });
      return response.data;
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ?? 'Error al actualizar el cupón';
      throw new Error(msg);
    }
  },
);
